function SmartTabsCustom(id, appUrl, shopName, section_id) {
    let url = window.location.protocol + '//' + window.location.host + window.location.pathname;
    let collectionHandleMatch = url.match("collections/(.*)/products");
    let collectionHandle = (collectionHandleMatch !== null) ? collectionHandleMatch[1].toLowerCase() : null;
    this.load = function(data, tobiSettings) {
        let settings = data.settings;
        let colors = data.colors;
        let layout = data.layout;
        let staticTabs = data.static_tabs;
        let chargesAccepted = data.charges_accepted;
        if (settings.shop_id === 33741) {
            getNonAsync('https://smart-tabs-custom.tkdigital.co.uk/app/tabs/' + settings.shop_id + '/settings', function(data) {
                settings = data.settings;
                colors = data.colors;
                layout = data.layout;
                staticTabs = data.static_tabs;
                chargesAccepted = data.charges_accepted
            })
        }
        if (section_id == null) return;
        window.tabsId = id;
        window.forceAccordion = id;
        let inPreview = window.location.href.indexOf('smart-tabs-custom-preview') !== -1;
        if (!inPreview)
            if (!settings.enabled) return;
        let descriptionBlock = document.querySelector('div[itemprop=description]');
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .product-single__description");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .product-description-wrapper");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .description");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .product-description");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .prodescript");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .desc_div_contain");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .smart-tabs-custom-description");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .product__info__detailed");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .ProductMeta__Description");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .product-description-wrapper");
        if (descriptionBlock === null || descriptionBlock === undefined) descriptionBlock = document.querySelector("#shopify-section-" + section_id + " .product-item-caption-desc");
        if (descriptionBlock === null || descriptionBlock === undefined) {
            console.log(id);
            console.log('Failed to find product description for SmartTabs app.');
            return
        }
        let originalDescription = $(descriptionBlock);
        let tags = originalDescription.find(settings.header_tab_tag);
        let tabs = [];
        let excludedTabs = [];
        if (tags.length === 0) {
            if (!settings.is_default_tab) tabs.push({
                'label': null,
                'content': originalDescription.html().trim()
            });
            else tabs.push({
                'label': settings.default_tab_title === '' ? 'Description' : settings.default_tab_title,
                'content': originalDescription.html().trim()
            })
        } else {
            originalDescription.contents().after().filter(function() {
                if (this.nodeType !== 3) return !1;
                if (this.nodeValue == null) return !1;
                return this.nodeValue.replace(/\s/g, '').length > 0
            }).wrap('<p></p>').end()
        }
        let tagsCount = 0;
        for (let i = 0; i < tags.length; i++) {
            let tag = tags[i];
            let nextTag = tags[i + 1];
            let content = '';
            if (settings.is_default_tab && tagsCount === 0) {
                $($(tag).prevAll().get().reverse()).each(function(key, element) {
                    content += element.outerHTML
                });
                if (content === '') {
                    if (nextTag !== undefined) {
                        $(tag).nextUntil(nextTag.tagName.toLowerCase()).each(function(key, element) {
                            content += element.outerHTML
                        });
                        tabs.push({
                            'label': tag.innerHTML.trim(),
                            'content': content.trim()
                        })
                    } else {
                        $(tag).nextAll().each(function(key, element) {
                            content += element.outerHTML
                        });
                        tabs.push({
                            'label': tag.innerHTML.trim(),
                            'content': content.trim()
                        })
                    }
                    tagsCount++;
                    continue
                }
                tabs.push({
                    'label': settings.default_tab_title === '' ? 'Description' : settings.default_tab_title,
                    'content': content.trim()
                })
            } else if (tagsCount === 0) {
                $($(tag).prevAll().get().reverse()).each(function(key, element) {
                    content += element.outerHTML
                });
                tabs.push({
                    'label': null,
                    'content': content.trim()
                })
            }
            tagsCount++;
            if (nextTag !== undefined) {
                content = '';
                $(tag).nextUntil(nextTag.tagName.toLowerCase()).each(function(key, element) {
                    content += element.outerHTML
                })
            } else {
                content = '';
                $(tag).nextAll().each(function(key, element) {
                    content += element.outerHTML
                })
            }
            if (tagsCount === 0) tabs.push({
                'label': tag.innerHTML.trim(),
                'content': content.trim()
            });
            else tabs.push({
                'label': tag.innerHTML.trim(),
                'content': content.trim()
            })
        }
        if (settings.content_below_tabs_type !== 'off') {
            for (let i = 0; i < tabs.length; i++) {
                let tab = tabs[i];
                let separatorHTag = '<' + settings.content_below_tabs_heading.toLowerCase() + '>';
                let separatorIndex = tab.content.indexOf(separatorHTag);
                if (separatorIndex === -1) continue;
                excludedTabs.push(tab.content.substr(tab.content.indexOf(separatorHTag)));
                tabs[i].content = tab.content.substr(0, tab.content.indexOf(separatorHTag))
            }
        }
        let product = null;
        for (let i = 0; i < staticTabs.length; i++) {
            let tab = staticTabs[i];
            if (!tab.active) continue;
            if (tab.type === 'Tobi - SMS & Messenger marketing') {
                if (tobiSettings === undefined) continue;
                if (getCookie('tobi_smart_tabs_closed') === 'true' || getCookie('mc_opted_in') === !0) continue
            }
            if (tab.excluded_products.length > 0) {
                if (!product) product = getJSON(url + '.js');
                if (!product || tab.excluded_products.includes(product.id)) continue
            }
            if (!tab.filters_active) {
                tabs.push({
                    'label': tab.title,
                    'content': tab.type !== 'Custom' ? null : !tab.static_content ? '' : tab.static_content.trim(),
                    'type': tab.type,
                });
                continue
            }
            if (!product) product = getJSON(url + '.js');
            if (!product) {
                tabs.push({
                    'label': tab.title,
                    'content': tab.type !== 'Custom' ? null : !tab.static_content ? '' : tab.static_content.trim(),
                    'type': tab.type,
                });
                continue
            }
            let productExists = tab.included_products.includes(product.id);
            let collectionExists = tab.included_collections.includes(collectionHandle);
            let typeExists = tab.included_types.includes(product.type.toLowerCase());
            let vendorExists = tab.included_vendors.includes(product.vendor.toLowerCase());
            if (!productExists && !collectionExists && !typeExists && !vendorExists) continue;
            tabs.push({
                'label': tab.title,
                'content': tab.type !== 'Custom' ? null : !tab.static_content ? '' : tab.static_content.trim(),
                'type': tab.type,
            })
        }
        descriptionBlock.style.display = 'none';
      	window['buzzTabsCustom_'+section_id] = new BuzzTabsObj(section_id);
        window['buzzTabsCustom_'+section_id].loadCss(colors, layout, settings);
        window['buzzTabsCustom_'+section_id].build(tabs, excludedTabs, descriptionBlock, chargesAccepted, id, shopName, settings, tobiSettings);
        window['buzzTabsCustom_'+section_id].generate();
        window['buzzTabsCustom_'+section_id].handleEvents(settings);
        let maxWidth = jQuery('.smart-tabs-custom-wrapper').outerWidth(!0) - 10;
        let tabNavWidth = jQuery('.smart-tabs-custom-navigation-links').outerWidth(!0);
        let forceAccordion = tabNavWidth >= maxWidth;
        if (settings.layout_style !== 'auto') {
            window.forceAccordion = settings.layout_style === 'always_accordion';
            window['buzzTabsCustom_'+section_id].switchTabsAccordion(settings);
            return
        }
        window.forceAccordion = forceAccordion;
        window['buzzTabsCustom_'+section_id].switchTabsAccordion(settings);
        $(window).resize(function() {
            maxWidth = jQuery('.smart-tabs-custom-wrapper').outerWidth(!0) - 10;
            forceAccordion = tabNavWidth >= maxWidth;
            if (!window.forceAccordion && !forceAccordion) return;
            if (window.forceAccordion && forceAccordion) return;
            window.forceAccordion = forceAccordion;
            window['buzzTabsCustom_'+section_id].switchTabsAccordion(settings)
        });

        function getCookie(name) {
            name = name + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1)
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length)
                }
            }
            return ""
        }
    };

    function get(url, callback) {
        jQuery.get(url, callback)
    }

    function getNonAsync(url, callback) {
        jQuery.ajax({
            url: url,
            success: callback,
            async: !1
        })
    }

    function getJSON(url) {
        let response = null;
        jQuery.ajax({
            url: url,
            dataType: 'json',
            async: !1,
            success: function(data) {
                response = data
            }
        });
        return response
    }
}
function BuzzTabsObj(section_id) {
    let build = function(tabs, excludedTabs, descriptionBlock, chargesAccepted, id, shopName, settings, tobiSettings) {
        let wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('smart-tabs-custom-wrapper');
        wrapperDiv.classList.add('Rte');
        wrapperDiv.setAttribute('style', 'margin: 15px 0');
        let navigationWrapper = document.createElement('div');
        navigationWrapper.classList.add('smart-tabs-custom-navigation-wrapper');
        let contentWrapper = document.createElement('div');
        contentWrapper.classList.add('smart-tabs-custom-content-wrapper');
        let navigationLinks = document.createElement('div');
        navigationLinks.classList.add('smart-tabs-custom-navigation-links');
        let nextTabActive = settings.open_first_accordion;
        for (let i = 0; i < tabs.length; i++) {
            let tab = tabs[i];
            if (i === 0 && !tab.label) {
                let untabbedContent = document.createElement('div');
                untabbedContent.classList.add('smart-tabs-custom-untabbed-content');
                untabbedContent.innerHTML = tab.content;
                wrapperDiv.appendChild(untabbedContent);
                continue
            }
            let navigationLi = document.createElement('div');
            if (nextTabActive) navigationLi.classList.add('smart-tabs-custom-navigation-li-active');
            navigationLi.classList.add('smart-tabs-custom-navigation-li');
            navigationLi.setAttribute('data-tab-link-id', i);
            navigationLi.innerHTML = tab.label;
            let plusSymbol = document.createElement('span');
            plusSymbol.classList.add('smart-tabs-custom-accordion-symbol', 'smart-tabs-custom-accordion-plus');
            plusSymbol.innerHTML = '&#43;';
            navigationLi.append(plusSymbol);
            let minusSymbol = document.createElement('span');
            minusSymbol.classList.add('smart-tabs-custom-accordion-symbol', 'smart-tabs-custom-accordion-minus');
            minusSymbol.innerHTML = '&#8722;';
            navigationLi.append(minusSymbol);
            navigationLinks.append(navigationLi);
            let contentBlock = document.createElement('div');
            if (nextTabActive) {
                contentBlock.classList.add('smart-tabs-custom-content-block-active');
                nextTabActive = !1
            }
            contentBlock.classList.add('smart-tabs-custom-content-block');
            contentBlock.setAttribute('id', 'smart-tabs-custom-content-' + i + '-' + section_id);
            contentBlock.innerHTML = tab.content;
            if (tab.type !== undefined) {
                if (tab.type === 'Custom') contentBlock.innerHTML = tab.content;
                else if (tab.type === 'Judge.me reviews') contentBlock.innerHTML = '<div class="static-tab-content" id="smart-tabs-custom-judge-me-reviews"></div>';
                else if (tab.type === 'Shopify reviews') contentBlock.innerHTML = '<div class="static-tab-content" id="smart-tabs-custom-shopify-reviews"></div>';
                else if (tab.type === 'YotPo reviews') contentBlock.innerHTML = '<div class="static-tab-content" id="smart-tabs-custom-yotpo-reviews"></div>';
                else if (tab.type === 'Loox') contentBlock.innerHTML = '<div class="static-tab-content" id="smart-tabs-custom-loox-reviews"></div>';
                else if (tab.type === 'Stamped') contentBlock.innerHTML = '<div class="static-tab-content" id="smart-tabs-custom-stamped-reviews"></div>';
                else if (tab.type === 'Ali') contentBlock.innerHTML = '<div class="static-tab-content" id="smart-tabs-custom-ali-reviews"></div>';
                else if (tab.type === 'Tobi - SMS & Messenger marketing' && tobiSettings !== undefined) contentBlock.innerHTML = '<div class="static-tab-content" id="smart-tabs-custom-tobi-block"></div>'
            }
            contentWrapper.append(contentBlock)
        }
        let excludedHTML = '';
        for (let i = 0; i < excludedTabs.length; i++) {
            let tab = excludedTabs[i];
            excludedHTML += tab
        }
        navigationWrapper.append(navigationLinks);
        wrapperDiv.append(navigationWrapper);
        wrapperDiv.append(contentWrapper);
        if (!chargesAccepted && id !== 7474 && id !== 7721 && id !== 2) {
            let branding = document.createElement('div');
            branding.classList.add('smart-tabs-custom-branding');
            let brandingLink = document.createElement('a');
            brandingLink.setAttribute('href', 'https://apps.shopify.com/smart-tabs-custom?utm_source=' + shopName + '&utm_medium=smart_tabs_shop')
            brandingLink.setAttribute('target', '_blank');
            brandingLink.innerHTML = 'Smart tabs';
            branding.append(brandingLink);
            wrapperDiv.append(branding)
        }
        if (excludedHTML !== '') {
            let excludedContent = document.createElement('div');
            excludedContent.classList.add('smart-tabs-custom-excluded-content');
            excludedContent.innerHTML = excludedHTML;
            wrapperDiv.append(excludedContent)
        }
        if (settings.has_static_content) {
            let staticContent = document.createElement('div');
            staticContent.classList.add('smart-tabs-custom-static-content');
            staticContent.style.padding = '15px 0';
            staticContent.innerHTML = settings.static_content;
            wrapperDiv.appendChild(staticContent)
        }
        descriptionBlock.parentNode.insertBefore(wrapperDiv, descriptionBlock.nextSibling)
    };
    let loadCss = function(colors, layout, settings) {
        let customCss = '';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li{display: inline-block;cursor:pointer;padding: 13px 15px;position:relative;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li.smart-tabs-custom-navigation-accordion{display: block;cursor:pointer;padding: 13px 15px;position:relative;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li{background-color: ' + colors.inactive_background_color + ';color: ' + colors.inactive_text_color + '!important;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li{border: ' + layout.border_width + 'px solid ' + colors.border_color + '; border-radius: ' + layout.border_radius + 'px;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li{font-size: ' + layout.font_size + ';line-height: ' + layout.heading_height + '}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li{margin: ' + layout.tab_margin_top + 'px ' + layout.tab_margin_right + 'px ' + layout.tab_margin_bottom + 'px ' + layout.tab_margin_left + 'px;}';
        if (!(layout.border_width > 1 || layout.border_radius > 1 || layout.content_border_width != 1 || layout.content_border_radius > 1 || layout.tab_margin_bottom > 0))
            customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li:not(:last-of-type) {border-bottom: none;}';
        if (layout.title_font_style === 'italic') customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li{font-style: italic;}';
        if (layout.title_font_style === 'bold') customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li{font-weight: bold;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li:not(.smart-tabs-custom-navigation-li-active):hover {background-color: ' + layout.tab_hover_color + ';}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li-active{background-color: ' + colors.title_background_color + ';color: ' + colors.title_text_color + '!important;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li-active{border: ' + layout.border_width + 'px solid ' + colors.content_border_color + '; border-radius: ' + layout.border_radius + 'px;}';
        if (!(layout.border_width > 1 || layout.border_radius > 1 || layout.content_border_width != 1 || layout.content_border_radius > 1 || layout.tab_margin_bottom > 0))
            customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li-active{border-bottom: ' + layout.border_width + 'px solid ' + colors.content_background_color + ' !important;margin: ' + layout.tab_margin_top + 'px ' + layout.tab_margin_right + 'px -1px ' + layout.tab_margin_left + 'px !important;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-content-block {background-color: ' + colors.content_background_color + '; color: ' + colors.content_text_color + '; padding: ' + layout.content_padding + 'px; }';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-content-block p {background-color: ' + colors.content_background_color + '; color: ' + colors.content_text_color + ' !important;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-content-block {border: ' + layout.content_border_width + 'px solid ' + colors.content_border_color + '; border-radius: ' + layout.content_border_radius + 'px;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-content-block-clone {display: block !important;}';
        customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-accordion-symbol {position: absolute;font-size:25px;right: 12px;margin: auto;}';
        if (settings.custom_css_active) customCss += settings.custom_css;
        if (settings.content_below_tabs_type === 'on')
            customCss += '#shopify-section-' + section_id + ' .smart-tabs-custom-excluded-content ' + settings.content_below_tabs_heading.toLowerCase() + ' {display:none;}';
        $('head').append('<style type="text/css">.smart-tabs-custom-wrapper{clear:both;}.smart-tabs-custom-navigation-wrapper{text-align: left;}.smart-tabs-custom-navigation-links {display: inline-block;}.smart-tabs-custom-content-block-active{display:block !important;}.smart-tabs-custom-content-block{display:none;}.smart-tabs-custom-untabbed-content,.smart-tabs-custom-excluded-content{padding: 15px 0;}#ruler{visibility:hidden;white-space:nowrap}.smart-tabs-custom-branding {text-align: right;font-size: 11px;margin-top: 5px;}.smart-tabs-custom-branding a {border-bottom: 0 !important;text-decoration: none!important;}' + customCss + '</style>')
    };
    let generate = function() {
        let shopifySource = document.getElementById("shopify-product-reviews");
        let shopifyTarget = document.getElementById("smart-tabs-custom-shopify-reviews");
        if (shopifySource && shopifyTarget) shopifyTarget.appendChild(shopifySource);
        let judgeMeSource = document.getElementById("judgeme_product_reviews");
        let judgeMeTarget = document.getElementById("smart-tabs-custom-judge-me-reviews");
        if (judgeMeSource && judgeMeTarget) judgeMeTarget.appendChild(judgeMeSource);
        let yotPoSource = document.getElementsByClassName("yotpo-main-widget");
        let yotPoTarget = document.getElementById("smart-tabs-custom-yotpo-reviews");
        if (yotPoSource.length > 0 && yotPoTarget) yotPoTarget.appendChild(yotPoSource[0]);
        let looxSource = document.getElementById("looxReviews");
        let looxTarget = document.getElementById("smart-tabs-custom-loox-reviews");
        if (looxSource && looxTarget) looxTarget.appendChild(looxSource);
        let stampedSource = document.getElementById("stamped-main-widget");
        let stampedTarget = document.getElementById("smart-tabs-custom-stamped-reviews");
        if (stampedSource && stampedTarget) stampedTarget.appendChild(stampedSource);
        let aliSource = document.getElementById("shopify-ali-review");
        let aliTarget = document.getElementById("smart-tabs-custom-ali-reviews");
        if (aliSource && aliTarget) aliTarget.appendChild(aliSource);
        let kiwiSource = document.getElementById("KiwiSizingChart");
        let kiwiTarget = document.getElementById("kiwi-sizing-guide");
        if (kiwiSource && kiwiTarget) kiwiTarget.appendChild(kiwiSource)
    };
    let handleEvents = function(settings) {
        jQuery("#shopify-section-" + section_id + " .smart-tabs-custom-navigation-li").click(function() {
            let clickedLink = jQuery(this);
            let linkId = clickedLink.data().tabLinkId + '-' + section_id;
            let tabsContent = jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-wrapper');
            let activeLi = jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li.smart-tabs-custom-navigation-li-active');
            if (activeLi.length > 0 && !settings.allow_multiple_open_accordion) {
                let activeLinkId = jQuery(activeLi[0]).data().tabLinkId + '-' + section_id;
                tabsContent.append(jQuery('#shopify-section-' + section_id + ' #smart-tabs-custom-content-' + activeLinkId).removeClass('smart-tabs-custom-content-block-clone'))
            }
            if (!window.forceAccordion) {
                jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li').removeClass('smart-tabs-custom-navigation-li-active');
                clickedLink.addClass('smart-tabs-custom-navigation-li-active');
                jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block-clone').remove();
                jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block').removeClass('smart-tabs-custom-content-block-active');
                jQuery('#shopify-section-' + section_id + ' #smart-tabs-custom-content-' + linkId).addClass('smart-tabs-custom-content-block-active');
                return
            }
            if (clickedLink.hasClass('smart-tabs-custom-navigation-li-active')) {
                clickedLink.removeClass('smart-tabs-custom-navigation-li-active');
                clickedLink.find('.smart-tabs-custom-accordion-plus').css('display', 'inline');
                clickedLink.find('.smart-tabs-custom-accordion-minus').css('display', 'none');
                if (!settings.allow_multiple_open_accordion) jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block-clone').remove();
                else {
                    tabsContent.append(clickedLink.next('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block-clone').removeClass('smart-tabs-custom-content-block-clone'))
                }
            } else {
                clickedLink.addClass('smart-tabs-custom-navigation-li-active');
                if (!settings.allow_multiple_open_accordion) {
                    jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-accordion-minus').css('display', 'none');
                    jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li').removeClass('smart-tabs-custom-navigation-li-active');
                    jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block-clone').remove();
                    jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block').removeClass('smart-tabs-custom-content-block-active');
                    jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-accordion-plus').css('display', 'inline');
                    clickedLink.addClass('smart-tabs-custom-navigation-li-active')
                }
                jQuery('#shopify-section-' + section_id + ' #smart-tabs-custom-content-' + linkId).addClass('smart-tabs-custom-content-block-clone').insertAfter(clickedLink);
                clickedLink.find('.smart-tabs-custom-accordion-minus').css('display', 'inline');
                clickedLink.find('.smart-tabs-custom-accordion-plus').css('display', 'none')
            }
        })
    };
    let switchTabsAccordion = function(settings) {
        let navigationLink = jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li');
        let activeLink = jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-li-active').first();
        navigationLink.removeClass('smart-tabs-custom-navigation-li-active');
        if (activeLink.length === 0) {
            activeLink = navigationLink.first();
            if (window.forceAccordion && !settings.allow_multiple_open_accordion) {
                $('#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-links').css('display', 'block');
                navigationLink.addClass('smart-tabs-custom-navigation-accordion');
                jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block-clone').remove();
                navigationLink.find('.smart-tabs-custom-accordion-plus').css('display', 'inline');
                navigationLink.find('.smart-tabs-custom-accordion-minus').css('display', 'none');
                jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block').removeClass('smart-tabs-custom-content-block-active');
                return
            }
        }
        if (activeLink.length === 0) return;
        activeLink.addClass('smart-tabs-custom-navigation-li-active');
        let activeLinkId = activeLink.first().data().tabLinkId + '-' + section_id;
        if (window.forceAccordion) {
            $('#shopify-section-' + section_id + ' .smart-tabs-custom-navigation-links').css('display', 'block');
            navigationLink.addClass('smart-tabs-custom-navigation-accordion');
            jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block-clone').remove();
            navigationLink.find('.smart-tabs-custom-accordion-plus').css('display', 'inline');
            navigationLink.find('.smart-tabs-custom-accordion-minus').css('display', 'none');
            jQuery('#shopify-section-' + section_id + ' #smart-tabs-custom-content-' + activeLinkId).clone().addClass('smart-tabs-custom-content-block-clone').insertAfter(activeLink);
            jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block').removeClass('smart-tabs-custom-content-block-active');
            activeLink.find('.smart-tabs-custom-accordion-minus').css('display', 'inline');
            activeLink.find('.smart-tabs-custom-accordion-plus').css('display', 'none');
            return
        }
        navigationLink.find('.smart-tabs-custom-accordion-plus').css('display', 'none');
        navigationLink.find('.smart-tabs-custom-accordion-minus').css('display', 'none');
        navigationLink.removeClass('smart-tabs-custom-navigation-accordion');
        jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block-clone').remove();
        jQuery('#shopify-section-' + section_id + ' .smart-tabs-custom-content-block').removeClass('smart-tabs-custom-content-block-active');
        jQuery('#shopify-section-' + section_id + ' #smart-tabs-custom-content-' + activeLinkId).addClass('smart-tabs-custom-content-block-active')
    };
    return {
        build: build,
        generate: generate,
        loadCss: loadCss,
        handleEvents: handleEvents,
        switchTabsAccordion: switchTabsAccordion,
    }
};